<!--
     <SuperFilters
       :filters='QFilters'
       :props='{filter_props}'
       @update="update(QFilters)"
       disabled
     />
-->

<template>
    <div>
    <v-btn
      @click.stop="showFilters"
      :disabled="disabled"
      icon
      small
      rounded
    >
      <!-- TODO: change color on active some filter
            :color="active ? '#4c1ac4' : 'primary'"
      -->
      <v-icon
        color="primary"
        small
      > mdi-tune-vertical </v-icon>
    </v-btn>
  
    <!-- Add /edit dialog -->
    <v-dialog
      id="headfilters"
      max-width="400px"
      ref="headfilters"
      v-model="showFilterForm"
      @keydown.esc="close"
      persistent
    >
      <v-card
        class="mx-auto"
      >
  
        <v-card-title>
          <span class="qmkey-modal-h1 pb-0">{{ $vuetify.lang.translator('filters.advanced.filters') }}</span>
          <v-spacer></v-spacer>
          <v-btn class="qmkey-modal-dialog-close" text plain right small :ripple="false" @click="close">
            <v-icon :ripple="false" small>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>
  
        <v-card-text class="pt-3">
          <div style="display: flex; flex-direction: column;">
            <div
              v-for="filter in filters_list" 
              :key="filter" 
              class="m-2 pb-2"
            >
              <!-- FILTER -->
              <component
                :ref="filter"
                :is="filter"
                :filters="local_filters"
                :props="(local_props.filter_props || {})[filter]"
                :is_mobile="is_mobile"
                @update="update_filter"
              >
              <!-- TODO: Delete this and make FilterProcess correctly -->
              <!-- Change filter process activator -->
              <template v-slot:activator="{on, props, text, placeholder}" v-if="!is_mobile">
                <v-text-field
                  :value="text"
                  :placeholder="placeholder"
                  readonly
                  v-on="on"
                  chips
                  solo
                  flat
                  dense
                  filled
                  hide-details
                  :class="props.activator_class ? props.activator_class : 'component explorer-table-searchable-text'"
                  background-color="#f2f2f2"
                >
                  <v-icon
                    v-on="on"
                    slot="append"
                    color="primary"
                  >mdi-cog-clockwise</v-icon>
                </v-text-field>
              </template>
            
              </component>
            </div>
          </div>
        </v-card-text>
  
        <v-card-actions class="qmkey-modal-dialog-card-actions">
          
          <v-btn @click="cancelFilters"
            class="qmkey-modal-dialog-button-secondary"
          >
            {{ $vuetify.lang.translator('dialog.clear') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            @click="setFilters"
          >
            {{ $vuetify.lang.translator('dialog.send') }}
          </v-btn>
        </v-card-actions>
  
      </v-card>
    </v-dialog>
  </div>
</template>
  
  
<style lang="scss">
  @import "@/sass/explorer.scss";
  @import "@/sass/modalform.scss";
</style>
  
  
<script>
  import { QFilters } from '@/qunit/filters';
  import FilterSearch from './FilterSearch';
  import FilterDatesRange from './FilterDatesRange';
  import FilterAdvanced from './FilterAdvanced';
  import AdvancedFilter from './AdvancedFilter';
  import FilterUser from './FilterUser';
  import FilterProcess from './FilterProcess'
  import FilterCentro from './FilterCentro'
  import FilterList from './FilterList'
  
  export default {
    components: {
      FilterSearch,
      FilterDatesRange,
      FilterAdvanced,
      AdvancedFilter,
      FilterUser,
      FilterProcess,
      FilterCentro,
      FilterList,

    },
  
    name: 'SuperFilters',
    
  
    props: {
      filters: {
        type: QFilters,
        required: true,
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false
      },
      is_mobile: {
        type: Boolean, 
        default: false
      },
      props: {default: () => ({})},
    },
  
    data: () => ({
      showFilterForm: false,
      local_filters: new QFilters(),
      local_props: {},
      active: false,
    }),
  
    computed: {
      business_process() {
        return this.filters.get_filter_value('business_process');
      },
  
      centro_id() {
        return this.filters.get_filter_value('centro');
      },
      
      filters_list() {
        return (this.local_props || {}).filter_list || [];
      },
  
      
    },
  
    mounted() {
      this.pull_filters();
      this.pull_props();
    },
  
    methods: {
      close() {
        this.showFilterForm = false;
        this.local_props = {};
        this.cancelFilters();
      },
  
      cancelFilters() {
        this.local_filters = this.filters.copy(['business_process','centro']);
      },
  
      setFilters() {
        this.active = false;
        let filters = new QFilters();
        for (const filter of this.filters_list) {
          if (!!this.$refs[filter] && !!this.$refs[filter][0].get_value) {
            filters = filters.merge(this.$refs[filter][0].get_value())
            if (Object.keys(this.$refs[filter][0].get_value().as_query()).length > 0) {
              this.active = true;
            }
          }
        }
        this.$emit("update", filters);
        this.close();
      },

      update_filter(filter) {
        let new_filter = filter
        if (!(filter instanceof QFilters)) {
          new_filter = new QFilters({[filter.name]:filter})
        }
        this.local_filters = this.local_filters.merge(new_filter);
      },
  
      showFilters() {
        this.pull_filters();
        this.pull_props();
        this.showFilterForm = true;
      },

      pull_filters() {
        this.local_filters = new QFilters(this.filters);
      },

      pull_props() {
        this.local_props = {...this.props};
      },
  
    },
  
    watch: {
      filters() {
        this.pull_filters();
      },
      props() {
        this.pull_props();
      },
    }
  }
</script>
  